import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Container, Row } from "react-bootstrap";
import Select, { components } from 'react-select';
import { BiSolidFoodMenu } from "react-icons/bi";
import * as colors from "../../assets/css/Colors";

// Import assets
import Darkimg from '../../assets/img/curve2.png';
import whiteimg from '../../assets/img/curve1.png';
import Darkbg from '../../assets/img/hero-section-black.webp';
import whitebg from '../../assets/img/hero-section-white.webp';
import { FaLocationDot } from "react-icons/fa6";
import { RiEnglishInput } from "react-icons/ri";
import Image_png from "../../components/Image_png";

// Select options
const options = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
];

const Hero = () => {
    // State for managing dark/light mode
    const [colorScheme, setColorScheme] = useState(
        window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
    );

    useEffect(() => {
        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        const handleChange = (e) => {
            setColorScheme(e.matches ? 'dark' : 'light');
        };
        mediaQuery.addEventListener('change', handleChange);

        return () => {
            mediaQuery.removeEventListener('change', handleChange);
        };
    }, []);

    // Hover state management
    const [hovered, setHovered] = useState({});
    const handleMouseEnter = (id) => setHovered(prevState => ({ ...prevState, [id]: true }));
    const handleMouseLeave = (id) => setHovered(prevState => ({ ...prevState, [id]: false }));

    // Hover styles
    const divStyles = (isHovered) => ({
        backgroundColor: isHovered
            ? colorScheme === 'dark'
                ? colors.theme_black_color
                : colors.theme_white_color
            : '#181818c7',
        border: isHovered
            ? `1px solid ${colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color}`
            : '1px solid #626262',
        boxShadow: isHovered ? '0 6px 13px 6px #00000042' : 'none',
        transition: 'background-color 0.3s ease',
    });

    // Custom styles for React Select
    const customStyles = {
        control: (provided) => ({
            ...provided,
            display: 'flex',
            alignItems: 'center',
            border: 'none',
            boxShadow: 'none',
            height: '58px',
            borderRadius: '0',
            width: '100%',
        }),
        input: (provided) => ({
            ...provided,
            margin: '0px',
            paddingTop: '0px',
            paddingBottom: '0px',
            marginTop: '-2px',
        }),
        container: (provided) => ({
            ...provided,
        }),
        singleValue: (provided) => ({
            ...provided,
            display: 'flex',
            alignItems: 'center',
        }),
        placeholder: (provided) => ({
            ...provided,
            display: 'flex',
            alignItems: 'center',
        }),
        menu: (provided) => ({
            ...provided,
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected
                ? colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color
                : provided.backgroundColor,
            '&:hover': {
                backgroundColor: state.isSelected
                    ? colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color
                    : colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color,
                color: '#fff',
            },
        }),
        dropdownIndicator: (provided) => ({
            ...provided,
            display: 'none', // Hide the dropdown indicator (arrow)
        }),
    };

    // Custom component to include the icon inside the select

const Categories = ({ children, ...props }) => (
    <components.SingleValue {...props}>
    <BiSolidFoodMenu style={{ marginRight: 8, fontSize: 22 }} />
    {children}
</components.SingleValue>
);

const Pincode = ({ children, ...props }) => (
    <components.SingleValue {...props}>
        <FaLocationDot style={{ marginRight: 8, fontSize: 22 }} />
        {children}
    </components.SingleValue>
);

const Search = ({ children, ...props }) => (
    <components.SingleValue {...props}>
        <RiEnglishInput style={{ marginRight: 8, fontSize: 22 }} />
        {children}
    </components.SingleValue>
);

    const CategoriesPlaceholder = (props) => (
        <components.Placeholder {...props}>
            <BiSolidFoodMenu style={{ marginRight: 8, fontSize: 22 }} />
            {props.children}
        </components.Placeholder>
    );

    const PincodePlaceholder = (props) => (
        <components.Placeholder {...props}>
            <FaLocationDot style={{ marginRight: 8, fontSize: 22 }} />
            {props.children}
        </components.Placeholder>
    );

    const SearchPlaceholder = (props) => (
        <components.Placeholder {...props}>
            <RiEnglishInput style={{ marginRight: 8, fontSize: 22 }} />
            {props.children}
        </components.Placeholder>
    );

    return (
        <div className="str ind2-home">
            <div className="hom-head" style={{ backgroundImage: `url(${colorScheme === 'light' ? whitebg : Darkbg})` }}>
                <Container>
                    <Row>
                        <div className="ban-tit">
                            <h1>
                                <b>Learn Everything You Want to Know About <span style={{ color: colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color }}>
                                Education.
                                    <img src={colorScheme === 'light' ? whiteimg : Darkimg} alt="sharp" />
                                </span></b>
                                <br />
                                <span style={{ lineHeight: '32px', maxWidth:'767px', width:'100%', margin:'auto', display:'block' }}>
                                Find essential information on Government and Private Schools & Colleges. Learn about admission processes, academic standards, and more—all in one place to help you make informed educational choices.
                                </span>
                            </h1>
                        </div>
                        <div className="ban-search ban-sear-all">
                            <form name="filter_form" id="filter_form" className="filter_form">
                                <ul>
                                    <li className="sr-cate">
                                        <Select
                                            options={options}
                                            styles={customStyles}
                                            components={{ SingleValue: Categories, Placeholder: CategoriesPlaceholder }}
                                            placeholder="Select the categories you want information on..."
                                        />
                                    </li>
                                    <li className="sr-cit">
                                        <Select
                                            options={options}
                                            styles={customStyles}
                                            components={{ SingleValue: Pincode, Placeholder: PincodePlaceholder }}
                                            placeholder="Please enter the pincode..."
                                        />
                                    </li>
                                    <li className="sr-nor">
                                        <Select
                                            options={options}
                                            styles={customStyles}
                                            components={{ SingleValue: Search, Placeholder: SearchPlaceholder }}
                                            placeholder="Enter what you want to search here..."
                                        />
                                    </li>
                                    <li className="sr-btn">
                                        <input
                                            style={{ backgroundColor: colorScheme === 'dark' ? colors.theme_bg : colors.theme_fg }}
                                            type="submit"
                                            id="filter_submit"
                                            name="filter_submit"
                                            value="Search"
                                            className="filter_submit"
                                        />
                                    </li>
                                </ul>
                            </form>
                        </div>
                        <div className="ban-short-links">
                            <ul className="category-hero-section">
                                <li>
                                    <div
                                        className="hero-section-box"
                                        onMouseEnter={() => handleMouseEnter(1)}
                                        onMouseLeave={() => handleMouseLeave(1)}
                                        style={divStyles(hovered[1])}
                                    >
                                        <Image_png text={'reading'}/>
                                        <h4>Students</h4>
                                        <Link to="/India-Citizen-Card" className="fclick"></Link>
                                    </div>
                                </li>
                                <li>
                                    <div
                                        className="hero-section-box"
                                        onMouseEnter={() => handleMouseEnter(2)}
                                        onMouseLeave={() => handleMouseLeave(2)}
                                        style={divStyles(hovered[2])}
                                    >
                                        <Image_png text={'teacher'}/>
                                        <h4>Teachers</h4>
                                        <Link to="/India-Citizen-Profession-Card" className="fclick"></Link>
                                    </div>
                                </li>
                                <li>
                                    <div
                                        className="hero-section-box"
                                        onMouseEnter={() => handleMouseEnter(3)}
                                        onMouseLeave={() => handleMouseLeave(3)}
                                        style={divStyles(hovered[3])}
                                    >
                                       <Image_png text={'attendance'}/>
                                        <h4>Attendance</h4>
                                        <Link to="/India-Citizen-Profession-Card" className="fclick"></Link>
                                    </div>
                                </li>
                                <li>
                                    <div
                                        className="hero-section-box"
                                        onMouseEnter={() => handleMouseEnter(4)}
                                        onMouseLeave={() => handleMouseLeave(4)}
                                        style={divStyles(hovered[4])}
                                    >
                                         <Image_png text={'exam'}/>
                                         <h4>Exam</h4>
                                        <Link to="/India-Citizen-Profession-Card" className="fclick"></Link>
                                    </div>
                                </li>
                                <li>
                                    <div
                                        className="hero-section-box"
                                        onMouseEnter={() => handleMouseEnter(5)}
                                        onMouseLeave={() => handleMouseLeave(5)}
                                        style={divStyles(hovered[5])}
                                    >
                                       <Image_png text={'library'}/>
                                       <h4>Library</h4>
                                        <Link to="/India-Citizen-Profession-Card" className="fclick"></Link>
                                    </div>
                                </li>
                                <li>
                                    <div
                                        className="hero-section-box"
                                        onMouseEnter={() => handleMouseEnter(6)}
                                        onMouseLeave={() => handleMouseLeave(6)}
                                        style={divStyles(hovered[6])}
                                    >
                                         <Image_png text={'event'}/>
                                        <h4>Events</h4>
                                        <Link to="/India-Citizen-Card" className="fclick"></Link>
                                    </div>
                                </li>
                                <li>
                                    <div
                                        className="hero-section-box"
                                        onMouseEnter={() => handleMouseEnter(7)}
                                        onMouseLeave={() => handleMouseLeave(7)}
                                        style={divStyles(hovered[7])}
                                    >
                                        <Image_png text={'online-conference'}/>
                                        <h4>Online Course</h4>
                                        <Link to="/India-Citizen-Profession-Card" className="fclick"></Link>
                                    </div>
                                </li>
                                <li>
                                    <div
                                        className="hero-section-box"
                                        onMouseEnter={() => handleMouseEnter(8)}
                                        onMouseLeave={() => handleMouseLeave(8)}
                                        style={divStyles(hovered[8])}
                                    >
                                         <Image_png text={'blog'}/>
                                         <h4>Blogs</h4>
                                        <Link to="/India-Citizen-Profession-Card" className="fclick"></Link>
                                    </div>
                                </li>
                                <li>
                                    <div
                                        className="hero-section-box"
                                        onMouseEnter={() => handleMouseEnter(9)}
                                        onMouseLeave={() => handleMouseLeave(9)}
                                        style={divStyles(hovered[9])}
                                    >
                                          <Image_png text={'school'}/>
                                          <h4>Schools</h4>
                                        <Link to="/India-Citizen-Profession-Card" className="fclick"></Link>
                                    </div>
                                </li>
                                <li>
                                    <div
                                        className="hero-section-box"
                                        onMouseEnter={() => handleMouseEnter(10)}
                                        onMouseLeave={() => handleMouseLeave(10)}
                                        style={divStyles(hovered[10])}
                                    >
                                       <Image_png text={'collage'}/>
                                       <h4>Colleges</h4>
                                        <Link to="/India-Citizen-Profession-Card" className="fclick"></Link>
                                    </div>
                                </li>
                                <li>
                                    <div
                                        className="hero-section-box"
                                        onMouseEnter={() => handleMouseEnter(11)}
                                        onMouseLeave={() => handleMouseLeave(11)}
                                        style={divStyles(hovered[11])}
                                    >
                                         <Image_png text={'project'}/>
                                         <h4>Projects</h4>
                                        <Link to="/India-Citizen-Profession-Card" className="fclick"></Link>
                                    </div>
                                </li>
                                <li>
                                    <div
                                        className="hero-section-box"
                                        onMouseEnter={() => handleMouseEnter(12)}
                                        onMouseLeave={() => handleMouseLeave(12)}
                                        style={divStyles(hovered[12])}
                                    >
                                          <Image_png text={'research'}/>
                                           <h4> Reseaech Papers</h4>
                                        <Link to="/India-Citizen-Profession-Card" className="fclick"></Link>
                                    </div>
                                </li>
                                <li>
                                    <div
                                        className="hero-section-box"
                                        onMouseEnter={() => handleMouseEnter(13)}
                                        onMouseLeave={() => handleMouseLeave(13)}
                                        style={divStyles(hovered[13])}
                                    >
                                       <Image_png text={'training'}/>
                                       <h4> Career Counseling Class</h4>
                                        <Link to="/India-Citizen-Profession-Card" className="fclick"></Link>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </Row>
                </Container>
            </div>
        </div>
    );
}

export default Hero;
